import type { RolePermission } from "../Types/Roles/RolePermission";

/** Whether the user may add/edit KPI progress notes (role flag `editKPILinks` from API). */
export function hasKpiEditPermission(rp: RolePermission | undefined): boolean {
  if (!rp) return false;
  return !!rp.editKPILinks;
}